import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { SubCountiesComponent } from "../../sub-counties.component";

import { UserAccountApi, SubCountyApi, CountyApi } from '../../../../../../theme/services/sdk';
import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'

@Component({
  selector: 'sub-county-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,SubCountyApi,CountyApi,BaToastNotificationService]
})
export class SubCountyForm{

  public form:FormGroup;
  public name:AbstractControl;
  public county_id:AbstractControl;
  public submitted:boolean = false;

  county_list:Object;
  sub_county:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected subCounty:SubCountyApi, protected county:CountyApi, private route: ActivatedRoute, private router: Router, private toast: BaToastNotificationService, private data: SubCountiesComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'county_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.county_id = this.form.controls['county_id'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.county.find().subscribe((res)=>{
      this.county_list = res;
    })
    this.data.sub_county.subscribe(data=>this.sub_county=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let sc;

      if(this.sub_county['id']){
        sc = this.subCounty.upsert({
          id: this.sub_county['id'],
          name: self.name['value'],
          county_id: self.county_id['value'],
        })
      }else{
        sc = this.subCounty.create({
          name: self.name['value'],
          county_id: self.county_id['value'],
        })
      }

      sc.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.sub_county['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New sub-county added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/sub-counties/components/form/form.component.ts